import { Typography, TypographyProps } from '@spazious/dollhouse-uikit';

export interface LabelProps extends TypographyProps {
  label: string;
}

export const Label: React.FC<LabelProps> = ({ label, ...restProps }) => (
  <Typography size="large" style={{ flex: 1 }} variant="label" {...restProps}>
    {label}:&nbsp;
  </Typography>
);
